<template>
    <div>
        music
    </div>
</template>

<script>
    export default {
        name: "music"
    }
</script>

<style scoped>

</style>
